export const EULA_LINK = "http://supervision.earth/terms_and_conditions.txt";
export const PRIVACY_LINK = "http://supervision.earth/privacy_policy.txt";

export const BUTTON_PROPS = {
    type: "ghost" as "ghost" | "default" | "link" | "primary" | "dashed" | "danger" | undefined,
    shape: "round" as "circle" | "round" | "circle-outline" | undefined,
    size: 'default' as  "small" | "default" | "large" | undefined
};
